import { useEffect, useRef } from "react";

// Pile LIFO globale des handlers Escape actifs. Chaque modale monte son
// handler à l'ouverture, dépile au démontage. Ainsi Échap ne ferme QUE la
// modale du dessus, jamais plusieurs à la fois. Spec rev171 (2026-02).
const escStack = [];

/**
 * useEscapeClose — attache un handler `Escape` global qui ne se déclenche
 * que si l'instance appelante est le dernier élément de la pile
 * (autrement dit, la modale « du dessus »).
 *
 * @param {Function} onClose  Callback appelé quand la touche Échap est
 *                            pressée ET que le composant est en haut de
 *                            pile. Sera lu via ref, donc pas besoin de
 *                            useCallback côté appelant.
 */
export default function useEscapeClose(onClose, enabled = true) {
  const cbRef = useRef(onClose);
  useEffect(() => { cbRef.current = onClose; });

  useEffect(() => {
    if (!enabled) return undefined;
    const marker = {}; // identité unique pour cette instance
    escStack.push(marker);

    const onKey = (e) => {
      if (e.key !== "Escape") return;
      // Ne s'active que si je suis le TOP de la pile.
      if (escStack[escStack.length - 1] !== marker) return;
      e.preventDefault();
      e.stopPropagation();
      cbRef.current?.();
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      const i = escStack.indexOf(marker);
      if (i >= 0) escStack.splice(i, 1);
    };
  }, [enabled]);
}
